var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.391,
    height: 20.346,
    viewBox: "0 0 41.391 20.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-long-arrow-alt-left",
    "data-name": "Icon awesome-long-arrow-alt-left",
    d: "M12.386,24.127h27.9a1.109,1.109,0,0,0,1.109-1.109V17.844a1.109,1.109,0,0,0-1.109-1.109h-27.9V12.48A2.217,2.217,0,0,0,8.6,10.912L.649,18.863A2.217,2.217,0,0,0,.649,22L8.6,29.95a2.217,2.217,0,0,0,3.785-1.568Z",
    transform: "translate(0 -10.258)",
    fill: "#43a047"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirArrowLeft);
export default __webpack_public_path__ + "static/media/dir_arrow_left.c3e9af17c2f968ac297b2c31f285367b.svg";
export { ForwardRef as ReactComponent };